var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 62.465 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M929.263,416.349v44.9a3.362,3.362,0,0,1-3.483,2.553q-27.753-.012-55.505-.006A3.18,3.18,0,0,1,866.8,460.3q0-21.5,0-43a5,5,0,0,1,.06-.911,3.189,3.189,0,0,1,3.475-2.585q21.1,0,42.208,0,6.618,0,13.236,0a3.156,3.156,0,0,1,2.628,1.034A9.882,9.882,0,0,1,929.263,416.349ZM907.378,432.6H869.965V445h37.413Zm-15.552-3.232h34.26V416.978h-34.26Zm34.261,31.253V448.21h-34.26v12.407Zm-56.126-31.241h18.65V417h-18.65Zm.015,18.834v12.407h18.643V448.21ZM926.1,432.6H910.559V445H926.1Z",
    transform: "translate(-866.798 -413.799)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrick);
export default __webpack_public_path__ + "static/media/brick.2df6c6c2.svg";
export { ForwardRef as ReactComponent };